export function isString(myVar) {
    return (typeof myVar === 'string' || myVar instanceof String)
}

export function toTitleCase(str) {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

/**
 * Convert CamelCase (and namespaced) strings to snake_case.
 * Mirrors Ruby on Rails’ ActiveSupport String#underscore behavior.
 */
export function toUnderscore(str) {
    return str
        // convert Ruby namespace separators
        .replace(/::/g, '/')
        // insert underscore between consecutive capitals and capital-lowercase
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        // insert underscore between lowercase/digit and capital
        .replace(/([a-z\d])([A-Z])/g, '$1_$2')
        // dashes to underscores
        .replace(/-/g, '_')
        // downcase the whole lot
        .toLowerCase();
}


// Reduces the length of the str to length
export function truncateFromCenter(str, length) {
    if (str.length <= length) { return str }
    length = Number(length-1); // Allow room for the separator we'll be adding back in.
    const separator = '…';
    const fragmentSize = Math.floor(length/2);
    const startFragment = str.substring(0, fragmentSize);
    const endFragment = str.substring(str.length-fragmentSize, str.labelPrefix);
    return startFragment + '…' + endFragment;
}

export function numberToPrice(price, options={}) {
    const precision = (typeof options.precision !== 'undefined') ? options.precision : 2;
    const formatter = new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
    });
    return formatter.format(price);
}


// Prepare a string for interpolation into a RegExp.
// let str = "String.With.Regex.Characters";
// let escapedString = escapeForRegExp(str); //=> ""
// let regex = new RegExp(`^(${ escapedString }\.)`);
// https://stackoverflow.com/a/3561711/19588
export function escapeForRegExp(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/**
 * Encodes a string to be safely used within HTML attributes.
 * For example, if you're putting JSON data into a `data-` attribute via Javascript.
 * You might:
 * ```
 * myElement.dataset.myData = htmlEncode( JSON.stringify({ foo: 'bar' }) );
 * ```
 * This will ensure that the JSON string is properly escaped for use in an HTML attribute.
 * You can then decode it with `htmlDecode` and `JSON.parse` when you need to use it.
 *
 * This function replaces characters that have special meaning in HTML
 * (such as `&`, `<`, `>`, `"`, `'`, and `\`) with their corresponding
 * HTML entities. This prevents issues when including JSON or other
 * data as a string within HTML attributes.
 *
 * @param {string} str - The input string to be encoded.
 * @returns {string} - The encoded string, safe for use in HTML attributes.
 */
export function htmlEncode(str) {
    return str.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/\\/g, '&#92;');  // Escaping backslashes
}